import GroomingCarouselCard from './GroomingCarouselCard';

export default GroomingCarouselCard;
